const E = {
  Tests: 'Tests',
  AddSample: 'Add Sample',
  MassUpdate: 'Mass Update',
  CreateExcel: 'Save and Create Excel',
  CommentsTitle: 'Comments / Special Handling Instructions',
  CommentsDisclaimer: `The sample details and test assignment portion of the template can be pre-populated
  to make it faster to submit a job in the field, communicate sampling requirements to
  other team members, or to ensure consistent sampling and analysis throughout your
  project. All of the information that is pre-populated can be edited at the time
  of the actual submission.`,
  CommentsDisclaimer2:
    'Please note that a sample matrix is required to enable the test selection grid.',
  UpdateAll: 'Update All',
  SelectedTest: 'Selected Test',
  RequiredFields: 'Required Fields',
  CreateComposite: 'Create Composite',
  SampleID: 'Sample ID',
  Matrix: 'Matrix',
  Bottles: 'Bottles',
  SampledOnDate: 'Sampled On Date',
  SampledOnTime: 'Sampled On Time',
  MoreValues: 'More Values',
  SelectAll: 'Select All',
  Delete: 'Delete',
  MultiDelete: 'Multi Delete',
  Copy: 'Copy',
  Disjoin: 'Disjoin',
  SubmissionRequirements: 'SUBMISSION REQUIREMENTS',
  Optional: 'OPTIONAL',
  CustomerRequirements: 'Customer Requirements',
  MakeRequired: 'Make Required',
  AllSamples: 'All Samples',
  Exceptions: 'Exceptions',
  ParameterTitle:
    'Select an individual sample to change the associated parameter selection.',
  TestInformation: 'Test Information',
  BackToSample: 'Back to Sample',
  BackToSamples: 'Back to Samples',
  BackToTemplates: 'Back to Templates',
  BackToJobs: 'Back to Jobs',
  Hold: 'Hold',
  HOLD: 'HOLD',
  TestingDate: 'Testing Date',
  ProductionDate: 'Production Date',
  Day: 'Day',
  MultiDeleteSamplesConfirmation: 'Are you sure you want to delete all the selected samples',
  Warning1: 'This Submission contains future sampling dates',
  Warning2: 'Sampling dates are not complete.',
  Warning2ShelfLife: 'Testing Days are not Complete.',
  Warning3: 'Sample IDs are limited to 200 characters.',
  Warning4: 'Composites must have more than 1 bottle.',
  Warning5: 'All samples must have at least 1 bottle.',
  Warning6: 'Samples may not share the same ID, date, and time.',
  Warning7: 'You should have at least one Sample.',
  Warning8: 'Samples must have a Matrix.',
  Warning9: 'Samples must have at least 1 Test.',
  Warning10: 'Samples must have a Sample ID.',
  Warning11: 'Days must be in ascending order.',

  SamplesLimitWarning: 'Maximum 200 samples.',
  SampleIDManagement: 'Sample ID Management',
  IDManagement: 'ID Management',
  CreateSampleID: 'Create Sample ID',
  ManageSamples: 'Manage Samples',
  Description: 'Description',
  'Sample #': 'Sample #',
  COC: 'COC #',
  Filter: 'Filter',
  Clear: 'Clear',
  IDMDescription: 'Sample IDs routinely submitted for laboratory analysis can be saved, managed, and accessed by any member of your organization with a customer portal account. While creating and editing templates, the ID’s listed below will be available to select from.  This will help you to save time, minimize transcription errors and create consistency in your data.',
  emptyComposite: 'Composite sample must have at least 1 Test and must not have the same test as its individual component',
  moreThanOneBottelInFood: 'You have added a sample with multiple containers.  If this sample should be a composite, please remove and re-add as a composite.',
  qctype: 'QC Type',
  autoFillSampleId:'Auto-fill SampleID(1,2,3..)',
};

const F = {
  Tests: 'Analyses',
  AddSample: 'Ajouter un échantillon',
  MassUpdate: 'Modifier le poids',
  CreateExcel: 'Enregistrer et créer un fichier Excel',
  CommentsTitle:
    'Inscrire ici tout commentaire ou toute instruction de manipulation spéciale',
  CommentsDisclaimer:
    'Les renseignements sur l’échantillon et le choix d’analyses peuvent être préremplis pour faciliter l’envoi d’un dossier sur le terrain, transmettre les exigences d’échantillonnage aux autres membres de l’équipe, assurer un échantillonnage uniforme et garantir la cohérence des analyses tout au long de votre projet. L’information préremplie peut être modifiée au moment de l’envoi. ',
  CommentsDisclaimer2:
    'Une matrice doit être choisie pour afficher les choix d’analyses.',
  UpdateAll: 'Tout mettre à jour',
  SelectedTest: 'Analyses choisies',
  RequiredFields: 'Champs obligatoires',
  CreateComposite: 'Créer un composite',
  SampleID: 'ID de l’échantillon',
  Matrix: 'Matrice',
  Bottles: 'Contenants',
  SampledOnDate: 'Échantillonné le',
  SampledOnTime: 'Échantillonné à',
  MoreValues: 'Afficher plus de valeurs',
  SelectAll: 'Sélectionner tout',
  Delete: 'Supprimer',
  MultiDelete: 'Supprimer multiple',
  Copy: 'Copier',
  Disjoin: 'Séparer',
  SubmissionRequirements: 'EXIGENCES D’ENVOI',
  Optional: 'FACULTATIF',
  CustomerRequirements: 'Exigences du client',
  MakeRequired: 'Rendre obligatoire',
  AllSamples: 'Tous les échantillons',
  Exceptions: 'Exceptions',
  ParameterTitle:
    'Sélectionner un échantillon pour modifier le choix de paramètre.',
  BackToSample: 'Revenir à l’échantillon',
  BackToSamples: 'Revenir aux échantillons',
  BackToTemplates: 'Revenir aux modèles',
  BackToJobs: 'Revenir aux dossiers',
  TestingDate: "Date d'analyse",
  ProductionDate: 'Date de fabrication',
  Day: 'Jour',
  MultiDeleteSamplesConfirmation:
    'Êtes-vous certain de vouloir supprimer ces échantillons',
  Hold: 'Mettre en attente',
  HOLD: 'Mettre en attente',
  Warning1: "Cette soumission contient des dates d'échantillonnage futures", 
  Warning2: "Les dates d'échantillonnage ne sont pas complètes.",
  Warning2ShelfLife: 'Veuillez remplir la colonne Jour.',
  Warning3: 'Le champ ID de l’échantillon est limité à 200 caractères.',
  Warning4: "Les composites doivent avoir plus d'une bouteille.",
  Warning5: 'Tous les échantillons doivent avoir au moins 1 bouteille.',
  Warning6:
    'Les échantillons ne peuvent pas avoir le même ID ni les mêmes date et heure.',
  Warning7: 'Vous devez ajouter au moins un échantillon.',
  Warning8: 'Une matrice doit être choisie pour chaque échantillon.',
  Warning9: 'Au moins une analyse doit être choisie pour chaque échantillon.',
  Warning10: 'Un ID doit être indiqué pour chaque échantillon.',
  Warning11: 'Les jours doivent être en ordre croissant.',

  SamplesLimitWarning: 'limitées à 200 échantillons.',
  SampleIDManagement: 'Gestion du numéro d’identification de l’échantillon',
  IDManagement: 'Gestion du numéro d’identification',
  CreateSampleID: 'Créer un numéro d’identification de l’échantillon',
  ManageSamples: 'Gérer les échantillons',
  Description: 'Description',
  'Sample #': 'No d’échantillon',
  COC: 'No CDR',
  Filter: 'Filtrer',
  Clear: 'Effacer',
  emptyComposite: 'L’échantillon composite doit être associé à au moins 1 analyse et ne doit pas être associé à la même analyse que son composant individuel.',
  IDMDescription: 'Les numéros d’identification des échantillons régulièrement soumis à l’analyse en laboratoire peuvent être sauvegardés, gérés et accessibles par tout membre de votre organisation disposant d’un compte sur le portail client. Lors de la création et de la modification des modèles, vous pourrez choisir parmi les identifiants énumérés ci-dessous. Cela vous permettra de gagner du temps, de minimiser les erreurs de transcription et de créer une cohérence dans vos données.',
  moreThanOneBottelInFood: "Vous avez ajouté un échantillon avec plusieurs contenants.  Si cet échantillon est un composite, veuillez le supprimer et l'ajouter à nouveau en tant que composite",
  qctype: 'TYPE DE CQ',
};

export default { E, F };



// WEBPACK FOOTER //
// ./src/constants/translations/formsSamples.js